module.exports = __webpack_public_path__ + "img/image.3a65f559.png";